import { IntlShape } from 'react-intl';

export const getVatGroupLabel = (intl: IntlShape, group: { code: string; name: string }): string =>
    intl.formatMessage({ id: `vatRatesMatrix.family.${group.code}`, defaultMessage: group.name });
